import isEqual from "lodash.isequal";

export const getNumberOfAppliedFilters = (filtersInitialState, newFilters) => {
  const quantityFiltersSelected = Object.entries(filtersInitialState).reduce(
    (count, [key, initialValue]) => {
      const currentValue = newFilters[key];
      if (
        typeof currentValue === "object" &&
        currentValue !== null &&
        Object.values(currentValue).every((v) => v === false)
      ) {
        return count;
      }

      return !currentValue || isEqual(initialValue, currentValue)
        ? count
        : count + 1;
    },
    0
  );

  return quantityFiltersSelected;
};
